import camelCase from 'lodash/camelCase';
import includes from 'lodash/includes';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';

const camelToSnakeCase = (str: string) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

export default function deepMap(map: any) {
  const deeplyArray = function(obj: any, fn: any) {
    return obj.map(function(x: any) {
      return isPlainObject(x) ? deepMap(map)(x, fn) : x;
    });
  };

  return function(obj: any, fn: any): any {
    if (isArray(obj)) {
      return deeplyArray(obj, fn);
    }

    return map(mapValues(obj, function(v) {
      // eslint-disable-next-line no-nested-ternary
      return isPlainObject(v) ? deepMap(map)(v, fn) : isArray(v) ? deeplyArray(v, fn) : v;
    }), fn);
  };
};

export const convertKeysToCamelCaseDeeply = (obj: any) => deepMap(mapKeys)(obj, (val: any, key: any) =>
  includes(key, '_') ? camelCase(key) : key,
);

export const convertKeysToSnakeCaseDeeply = (obj: any) =>
  deepMap(mapKeys)(obj, (val: any, key: any) => camelToSnakeCase(key));
